import {
  CLEAN_SCAN,
  CLEAN_SCAN_IMG,
  GET_SCAN_PHOTO_ERROR,
  GET_SCAN_PHOTO_REQUEST,
  GET_SCAN_PHOTO_SUCCESS,
  SET_TYPE_SCAN,
} from './constants';

export const setScanType = (typeDoc: string, index: number | null) => ({
  type: SET_TYPE_SCAN,
  typeDoc,
  index,
});

export const getScanRequest = (scannerUrl: string) => ({
  type: GET_SCAN_PHOTO_REQUEST,
  payload: scannerUrl,
});

export const getScanSuccess = (res: any) => ({
  type: GET_SCAN_PHOTO_SUCCESS,
  payload: res,
});

export const getScanError = (error: Error | null) => ({
  type: GET_SCAN_PHOTO_ERROR,
  payload: error,
});

export const cleanScan = () => ({
  type: CLEAN_SCAN,
});

export const cleanScanImg = () => ({
  type: CLEAN_SCAN_IMG,
});

export type Actions =
  | ReturnType<typeof cleanScanImg>
  | ReturnType<typeof getScanRequest>
  | ReturnType<typeof getScanSuccess>
  | ReturnType<typeof getScanError>
  | ReturnType<typeof setScanType>
  | ReturnType<typeof cleanScan>;
